module.exports = __webpack_public_path__ + "img/pia-forenom.28148280.jpg";